console.log('init.js v2.7 ...');

(function init(){ console.log('init() ->');

  //INITFUNCTIONS
    //Start with a boilerplate
    boilerplate();

    //Show notice for outdated browsers
    //akoutdated(true);

    //Set body classes
    $('body').akbildschirm(true);

    //Adminmenu Functions
    adminmenu(); //Set keyboard shortcuts
    hidemessages(); //Set keyboard shortcuts

    //Process Forms
    $('.webform-container-inline').akwrapformitems('.form-item'); //?


  //Ajax

  $('.field-name-field-navfields a').akajax({
    closestSelector: '#container',
    findSelector: '.ajax',
    resultSelector: '#ajaxresult>article.node',
    transitions: true,
    ajaxcontainer: 'append',
    toggle: false,
    callbackIfExist: true,
    reloadIfExist: true,
    callback: function(){
      $('html, body').animate({
       scrollTop: $(".ajax").offset().top
     }, 250);
    }
  });

  //$('.view-events a, .view-events-kids a').akarm('article.node');


  //BASIC
    //Init Sandwich-Button
    $('.sandwich').aksandwich('.sandwich-button');

    //Init jPlayers
    //$('.akjplayerA').akjplayerA();
    $('.akjplayerV').akjplayerV();

    //Init Swipers
    $('.view-swiper').akViewSwiper();
    //$('.field-name-field-images-swiper').akImageSwiper();


  //EXTRA
    $('#node-10 .jp-controls').remove();
    $('#node-10 .jp-container').bind($.jPlayer.event.ended, function(event) {
      $(this).jPlayer("play");
    });

    $('.swiper-slide-active .akjplayerV .jp-container').bind($.jPlayer.event.ready, function(event) {
      $(this).jPlayer("play");
    });




  //EVENTS
  buttons();

  $('header').akautomenu(100);


  //Remove Ajax
  removeajaxresult();

  //Start Beatmaker
  //beatmaker();

})();

//CALLBACKS

  //Swipers

  // function akViewSwiper_onInit(swiper){  console.log('akViewSwiper_onInit('+swiper.activeIndex+')')
  //   countslides(swiper);
  // }

  function akViewSwiper_onSlideChangeStart(swiper){ console.log('akViewSwiper_onSlideChangeStart('+swiper.activeIndex+')')
    $('.akjplayerV .jp-container').jPlayer('pause');
    countslides(swiper);
  }

  function akViewSwiper_onSlideChangeEnd(swiper){  console.log('akViewSwiper_onSlideChangeStart('+swiper.activeIndex+')')
    $('.swiper-slide-active .akjplayerV .jp-container').jPlayer('play');
    swiper.update(true)
  }

  function countslides(swiper){
    $(swiper.container[0]).removeClass (function (index, css) { return (css.match(/(^|\s)swiper-index-\S+/g) || []).join(' '); }).addClass('swiper-index-'+swiper.activeIndex);
    if( !$(swiper.container[0]).find('.swiper-slide-next').length ) $(swiper.container[0]).addClass('swiper-index-last');
  }

  countslides( $('.akviewswiper>.swiper-container')[0].swiper ); //init


//BEATMAKER

  function beatmaker(){
    window.setTimeout(beatmaker, 1000 / 10);

    //EVENTS
    console.log('tick');

  }
